
import { Component, Prop, Vue } from 'vue-property-decorator';
import markdown from 'spa-ionata-admin/lib/services/markdown';
import Business from '../models/Business';

@Component({ components: {} })
export default class extends Vue {
  @Prop(Object) readonly business!: Business;

  get description(): string | undefined {
    if (!this.business?.locale) {
      return undefined;
    }
    const { description } = this.business.locale;
    if (!description) {
      return '';
    }
    return markdown(description);
  }
}
